import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux'
import { useFirestoreConnect, useFirebase, isEmpty, isLoaded } from 'react-redux-firebase'

import Loading from '../components/Loading';
import OnboardingAlert from '../components/OnboardingAlert';
import Page, { statusBreadcrumb } from './Page';
import { PlayerCard } from '../components/Player';
import { useSubmissionsSelector, useBodyClass } from '../hooks';

const NoPodcasts = () => (
  <div className="nothing-to-show text-center">
    <h2 className="h3">No podcasts to show</h2>
    <p className="lead">
      To get started, submit your content below
    </p>
    <div>
      <Link to="/submit" className="btn btn-primary">Submit content</Link>
    </div>
  </div>
);

const UserDashboardPage = () => {
  const auth = useSelector(state => state.firebase.auth)
  const firebase = useFirebase();
  const profile = useSelector(state => state.firebase.profile)
  const podcasts = useSubmissionsSelector();
  const { status } = useParams();

  const closeOnboardingAlert = () => {
    firebase.updateProfile({hasSeenOnboardingAlert: true})
  }

  let whereQuery = [["userId", "==", auth.uid]];
  let breadcrumbs = [];

  if(status) {
    whereQuery.push(['status', '==', status.replace('-', '_')])
    breadcrumbs.push({title: "Podcasts", link: "/podcasts"})
    breadcrumbs.push(statusBreadcrumb[status])
  }

  useFirestoreConnect({
    collection: 'submissions',
    where: whereQuery,
    orderBy: ["createdAt", "desc"]
  })


  if (!isLoaded(podcasts) || !isLoaded(profile)) {
    return (
      <Page title="Podcasts" breadcrumbs={breadcrumbs}>
        <Loading />
      </Page>
    )
  }

  if (isEmpty(podcasts)) {
    return (
      <Page title="Podcasts" breadcrumbs={breadcrumbs}>
        <NoPodcasts />
      </Page>
    )
  }


  return (
    <Page title="Podcasts" breadcrumbs={breadcrumbs}>
      <div className="row justify-content-center">
        <div className="col-12">
          { !profile.hasSeenOnboardingAlert && <OnboardingAlert onClose={closeOnboardingAlert} /> }
          <div className="players">
            <ul className="list-unstyled mb-0">
              {podcasts.map(podcast => (
                <li key={podcast.id}>
                  <PlayerCard podcast={podcast} />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Page>
  )
}

const AdminDashboardPage = () => {
  useBodyClass('admin');

  const profile = useSelector(state => state.firebase.profile)
  const podcasts = useSubmissionsSelector();
  const users = useSelector(state => state.firestore?.data?.users)
  const { userId, status } = useParams();

  useFirestoreConnect({
    collection: 'users'
  })

  let whereQuery = []
  let breadcrumbs = [];

  if (status) {
    whereQuery.push(['status', '==', status.replace('-', '_')])
    breadcrumbs.push({title: "Podcasts", link: "/podcasts"})
    breadcrumbs.push(statusBreadcrumb[status])
  } else if (userId) {
    const userName = users && userId in users && (users[userId].companyName || users[userId].name);
    whereQuery.push(['userId', '==', userId])
    breadcrumbs.push({title: "Podcasts", link: "/podcasts"})
    breadcrumbs.push({title: userName, link: ""})
  }

  useFirestoreConnect({
    collection: 'submissions',
    where: whereQuery.length > 0 ? whereQuery : undefined,
    orderBy: ["createdAt", "desc"]
  })

  if (!isLoaded(podcasts) || !isLoaded(profile)) {
    return <Loading />
  }

  const UserFilterLink = ({userId}) => {
    const userName = useSelector(state => {
      const users = state?.firestore?.data?.users

      if (!users || userId in users === false) {
        return "Unknown"
      }

      return users[userId].companyName || users[userId].name;
    });

    return (
      <Link to={`/podcasts/by-user/${userId}`}>
        {userName}
      </Link>
    )
  }

  return (
    <Page title="Podcasts" breadcrumbs={breadcrumbs}>
      <div className="row justify-content-center">
        <div className="col-12">
          <div className="players">
            <ul className="list-unstyled mb-0">
              {podcasts.map(podcast => (
                <li key={podcast.id}>
                  <PlayerCard podcast={podcast} extraInfo={<UserFilterLink userId={podcast.userId} />}/>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </Page>
  )
}

const DashboardPage = (props) => {
  const profile = useSelector(state => state.firebase.profile)

  if (!isLoaded(profile)) {
    return <Loading />
  }

  if (profile.isAdmin) {
    return <AdminDashboardPage {...props} />;
  }

  return <UserDashboardPage {...props} />;
};

export default DashboardPage;
